
import { useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { BotonesAndCargando } from '../../components/botones';
import { useModalStore, useNotasStore } from '../../../stores';
import { aprobarNotaIngreso } from '../../../services';
import { useQueryClient } from '@tanstack/react-query';


import Swal from 'sweetalert2';



export const FormAprobarIngresoStock = () => {


    const queryClient = useQueryClient();
    const { activarNota } = useNotasStore();
    const { modalFormToggle } = useModalStore();
    const [cargando, setCargando] = useState(false)
    const [ formAbono, setFormAbono ] = useState({ observacion: "", });
    const { observacion } = formAbono;



    const handleInputChange = ({ target }) => {
        setFormAbono({
            ...formAbono,
            [target.name]: target.value
        });
    }

    

    const handleCrearAbono = async(e) => {
        e.preventDefault();
        if( [observacion].includes('') ) {
            return Swal.fire('Error', 'la observación es obligatoria', 'error');
        }

        const { isConfirmed } = await Swal.fire({
            title: 'Aprobar Ingreso',
            text: `¿Esta seguro de aprobar este ingreso?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });

        if( !isConfirmed ) return;

        setCargando(true);
        const resp = await aprobarNotaIngreso({ observacion, id:activarNota.id });
        setCargando(false);

        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['todo-notas'] });
            modalFormToggle(false);
        }
    }



    return (

        
        <form onSubmit={ handleCrearAbono } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12}>
                    <TextField
                        label="Observacion"
                        fullWidth
                        placeholder="Observacion"
                        multiline
                        name="observacion"
                        value={ observacion }
                        onChange={ handleInputChange } 
                        size="small"
                    />
                </Grid>
            </Grid>

            <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Aprobar Ingreso'
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>
        </form>

    )
}
